export const NOAH_EOS_LP_MAINNET = '0x0eD7e52944161450477ee417DE9Cd3a859b14fD0'
